import { memo } from 'react';
import { Box } from '@chakra-ui/react';

import type { PlanRevampIconProperties } from './types';

const DEFAULT_DARK = '#121826';
const DEFAULT_PRIMARY = '#8B5CF6';

/** Figma 75913:6246 — code-branch */
export const DriverPanelCodeBranchIcon = memo(
  ({ width = 16, height = 16, color = DEFAULT_DARK }: PlanRevampIconProperties) => (
    <svg width={width} height={height} viewBox='0 0 16 16' fill='none' aria-hidden>
      <path
        d='M16 2.66667C16 1.196 14.804 0 13.3333 0C11.8627 0 10.6667 1.196 10.6667 2.66667C10.6667 3.90667 11.518 4.952 12.6667 5.24867V6.66667C12.6667 7.034 12.3673 7.33333 12 7.33333H4C3.766 7.33333 3.542 7.374 3.33333 7.44733V5.24867C4.482 4.952 5.33333 3.90667 5.33333 2.66667C5.33333 1.196 4.13733 0 2.66667 0C1.196 0 0 1.196 0 2.66667C0 3.90667 0.851333 4.952 2 5.24867V10.7507C0.851333 11.0473 0 12.0927 0 13.3327C0 14.8033 1.196 15.9993 2.66667 15.9993C4.13733 15.9993 5.33333 14.8033 5.33333 13.3327C5.33333 12.0927 4.482 11.0473 3.33333 10.7507V9.33267C3.33333 8.96533 3.63267 8.666 4 8.666H12C13.1027 8.666 14 7.76867 14 6.666V5.248C15.1487 4.95133 16 3.90667 16 2.66667ZM1.33333 2.66667C1.33333 1.93133 1.93133 1.33333 2.66667 1.33333C3.402 1.33333 4 1.93133 4 2.66667C4 3.402 3.402 4 2.66667 4C1.93133 4 1.33333 3.402 1.33333 2.66667ZM4 13.3333C4 14.0687 3.402 14.6667 2.66667 14.6667C1.93133 14.6667 1.33333 14.0687 1.33333 13.3333C1.33333 12.598 1.93133 12 2.66667 12C3.402 12 4 12.598 4 13.3333ZM13.3333 4C12.598 4 12 3.402 12 2.66667C12 1.93133 12.598 1.33333 13.3333 1.33333C14.0687 1.33333 14.6667 1.93133 14.6667 2.66667C14.6667 3.402 14.0687 4 13.3333 4Z'
        fill={color}
      />
    </svg>
  ),
);

DriverPanelCodeBranchIcon.displayName = 'DriverPanelCodeBranchIcon';

/** Figma 75913:6250 — table-list */
export const DriverPanelTableListIcon = memo(
  ({ width = 16, height = 16, color = DEFAULT_DARK }: PlanRevampIconProperties) => (
    <svg width={width} height={height} viewBox='0 0 16 16' fill='none' aria-hidden>
      <path
        d='M12.6667 1.33301H3.33333C1.49533 1.33301 0 2.82834 0 4.66634V11.333C0 13.171 1.49533 14.6663 3.33333 14.6663H12.6667C14.5047 14.6663 16 13.171 16 11.333V4.66634C16 2.82834 14.5047 1.33301 12.6667 1.33301ZM1.33333 6.66634H4V9.33301H1.33333V6.66634ZM5.33333 6.66634H14.6667V9.33301H5.33333V6.66634ZM14.6667 4.66634V5.33301H5.33333V2.66634H12.6667C13.7693 2.66634 14.6667 3.56367 14.6667 4.66634ZM3.33333 2.66634H4V5.33301H1.33333V4.66634C1.33333 3.56367 2.23067 2.66634 3.33333 2.66634ZM1.33333 11.333V10.6663H4V13.333H3.33333C2.23067 13.333 1.33333 12.4357 1.33333 11.333ZM12.6667 13.333H5.33333V10.6663H14.6667V11.333C14.6667 12.4357 13.7693 13.333 12.6667 13.333Z'
        fill={color}
      />
    </svg>
  ),
);

DriverPanelTableListIcon.displayName = 'DriverPanelTableListIcon';

/** Figma 75911:4494 — close */
export const DriverPanelCloseIcon = memo(
  ({ width = 10, height = 10, color = DEFAULT_DARK }: PlanRevampIconProperties) => (
    <svg width={width} height={height} viewBox='0 0 10 10' fill='none' aria-hidden>
      <path
        d='M5.91713 5.00876L9.81093 1.11484C10.0643 0.861559 10.0643 0.452035 9.81093 0.198752C9.55765 -0.0545318 9.14812 -0.0545318 8.89484 0.198752L5.00092 4.09267L1.10712 0.198752C0.853717 -0.0545318 0.444311 -0.0545318 0.191028 0.198752C-0.0623739 0.452035 -0.0623739 0.861559 0.191028 1.11484L4.08483 5.00876L0.191028 8.90268C-0.0623739 9.15597 -0.0623739 9.56549 0.191028 9.81877C0.317255 9.94512 0.483223 10.0086 0.649074 10.0086C0.814924 10.0086 0.980774 9.94512 1.10712 9.81877L5.00092 5.92485L8.89484 9.81877C9.02119 9.94512 9.18704 10.0086 9.35289 10.0086C9.51874 10.0086 9.68459 9.94512 9.81093 9.81877C10.0643 9.56549 10.0643 9.15597 9.81093 8.90268L5.91713 5.00876Z'
        fill={color}
      />
    </svg>
  ),
);

DriverPanelCloseIcon.displayName = 'DriverPanelCloseIcon';

/** Figma 75912:4836 — menu dots (horizontal; rotate 90° for vertical kebab) */
export const DriverPanelMenuDotsIcon = memo(
  ({ width = 18, height = 18, color = DEFAULT_DARK }: PlanRevampIconProperties) => (
    <Box
      as='span'
      display='inline-flex'
      alignItems='center'
      justifyContent='center'
      w={`${width}px`}
      h={`${height}px`}
      flexShrink={0}
      transform='rotate(90deg)'
    >
      <svg width='18' height='3' viewBox='0 0 17.9567 2.99267' fill='none' aria-hidden>
        <path
          d='M1.49632 2.99263C2.32271 2.99263 2.99263 2.32271 2.99263 1.49632C2.99263 0.669923 2.32271 0 1.49632 0C0.669923 0 0 0.669923 0 1.49632C0 2.32271 0.669923 2.99263 1.49632 2.99263Z'
          fill={color}
        />
        <path
          d='M8.97785 2.99263C9.80424 2.99263 10.4742 2.32271 10.4742 1.49632C10.4742 0.669923 9.80424 0 8.97785 0C8.15146 0 7.48153 0.669923 7.48153 1.49632C7.48153 2.32271 8.15146 2.99263 8.97785 2.99263Z'
          fill={color}
        />
        <path
          d='M16.4604 2.99263C17.2868 2.99263 17.9567 2.32271 17.9567 1.49632C17.9567 0.669923 17.2868 0 16.4604 0C15.634 0 14.964 0.669923 14.964 1.49632C14.964 2.32271 15.634 2.99263 16.4604 2.99263Z'
          fill={color}
        />
      </svg>
    </Box>
  ),
);

DriverPanelMenuDotsIcon.displayName = 'DriverPanelMenuDotsIcon';

interface ChevronProperties extends PlanRevampIconProperties {
  expanded?: boolean;
}

/** Figma 75912:4849 — chevron (filled triangle, primary purple) */
export const DriverPanelChevronIcon = memo(
  ({ width = 10, height = 6, color = DEFAULT_PRIMARY, expanded = false }: ChevronProperties) => (
    <Box
      as='span'
      display='inline-flex'
      alignItems='center'
      justifyContent='center'
      flexShrink={0}
      transform={expanded ? 'rotate(180deg)' : undefined}
      transition='transform 0.2s ease'
    >
      <svg width={width} height={height} viewBox='0 0 10 6' fill='none' aria-hidden>
        <path d='M5.00001 0L10 6H0L5.00001 0Z' fill={color} />
      </svg>
    </Box>
  ),
);

DriverPanelChevronIcon.displayName = 'DriverPanelChevronIcon';

/** Figma 75912:4897 — plus */
export const DriverPanelPlusIcon = memo(
  ({ width = 14, height = 14, color = DEFAULT_PRIMARY }: PlanRevampIconProperties) => (
    <svg width={width} height={height} viewBox='0 0 14 14' fill='none' aria-hidden>
      <path
        d='M13.125 6.125H7.875V0.875C7.875 0.391754 7.48325 0 7 0C6.51675 0 6.125 0.391754 6.125 0.875V6.125H0.875C0.391754 6.125 0 6.51675 0 7C0 7.48325 0.391754 7.875 0.875 7.875H6.125V13.125C6.125 13.6082 6.51675 14 7 14C7.48325 14 7.875 13.6082 7.875 13.125V7.875H13.125C13.6082 7.875 14 7.48325 14 7C14 6.51675 13.6082 6.125 13.125 6.125Z'
        fill={color}
      />
    </svg>
  ),
);

DriverPanelPlusIcon.displayName = 'DriverPanelPlusIcon';

/** Figma 75912:4855 — calendar-lines */
export const DriverPanelCalendarIcon = memo(
  ({ width = 16, height = 16, color = DEFAULT_PRIMARY }: PlanRevampIconProperties) => (
    <svg width={width} height={height} viewBox='0 0 16 16' fill='none' aria-hidden>
      <path
        d='M0 5.33333V4.66667C0 2.82867 1.49533 1.33333 3.33333 1.33333H4V0.666667C4 0.298667 4.298 0 4.66667 0C5.03533 0 5.33333 0.298667 5.33333 0.666667V1.33333H10.6667V0.666667C10.6667 0.298667 10.9647 0 11.3333 0C11.702 0 12 0.298667 12 0.666667V1.33333H12.6667C14.5047 1.33333 16 2.82867 16 4.66667V5.33333H0ZM16 6.66667V12.6667C16 14.5047 14.5047 16 12.6667 16H3.33333C1.49533 16 0 14.5047 0 12.6667V6.66667H16ZM8 12.6667C8 12.2987 7.702 12 7.33333 12H4C3.63133 12 3.33333 12.2987 3.33333 12.6667C3.33333 13.0347 3.63133 13.3333 4 13.3333H7.33333C7.702 13.3333 8 13.0347 8 12.6667ZM12.6667 10C12.6667 9.632 12.3687 9.33333 12 9.33333H4C3.63133 9.33333 3.33333 9.632 3.33333 10C3.33333 10.368 3.63133 10.6667 4 10.6667H12C12.3687 10.6667 12.6667 10.368 12.6667 10Z'
        fill={color}
      />
    </svg>
  ),
);

DriverPanelCalendarIcon.displayName = 'DriverPanelCalendarIcon';

/** Figma 75916:8817 — bars-filter (table header) */
export const DriverPanelBarsFilterIcon = memo(
  ({ width = 14, height = 14, color = '#708090' }: PlanRevampIconProperties) => (
    <svg width={width} height={height} viewBox='0 0 14 14' fill='none' aria-hidden>
      <path
        d='M1.75 2.625H12.25M3.5 7H10.5M5.25 11.375H8.75'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  ),
);

DriverPanelBarsFilterIcon.displayName = 'DriverPanelBarsFilterIcon';
